import { memo } from '@morphic-ts/common/es6/utils';
import { pipe } from 'fp-ts/es6/function';
import { showApplyConfig } from '../config';
import { ShowType, ShowURI } from '../hkt';
const coerce = (e) => e;
/**
 *  @since 0.0.1
 */
export const showNewtypeInterpreter = memo(() => ({
    _F: ShowURI,
    newtype: name => (a, config) => env => pipe(a(env).show, show => new ShowType(showApplyConfig(config)(coerce({ show: x => `<${name}>(${show.show(x)})` }), env, { show }))),
    newtypeIso: (iso, a, name, config) => env => pipe(a(env).show, show => new ShowType(showApplyConfig(config)({ show: x => `<${name}>(${show.show(iso.reverseGet(x))})` }, env, { show }))),
    newtypePrism: (prism, a, name, config) => env => pipe(a(env).show, show => new ShowType(showApplyConfig(config)({ show: x => `<${name}>(${show.show(prism.reverseGet(x))})` }, env, { show })))
}));
